import React, { useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";
import { Button } from "@/components/ui/button";
import { CalendarDays } from "lucide-react";
import { useFilters } from "@/context/FilterContext";
import { DATE_PRESETS, fmtDate } from "@/lib/format";

export function DateRangeFilter() {
  const { preset, range, applyPreset, setCustomRange } = useFilters();
  const [open, setOpen] = useState(false);
  const [draft, setDraft] = useState(undefined);

  const label =
    preset === "custom"
      ? `${range.start_date ? fmtDate(range.start_date) : "Start"} \u2013 ${
          range.end_date ? fmtDate(range.end_date) : "End"
        }`
      : DATE_PRESETS.find((p) => p.key === preset)?.label || "Range";

  const applyCustom = () => {
    if (draft?.from) {
      const s = draft.from.toISOString().slice(0, 10);
      const e = (draft.to || draft.from).toISOString().slice(0, 10);
      setCustomRange(s, e);
      setOpen(false);
    }
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          data-testid="date-range-filter-trigger"
          className="h-9 gap-2 rounded-full border-[var(--pb-border)] bg-white text-sm font-medium text-[#30383C]"
        >
          <CalendarDays className="h-4 w-4 text-[#526E7E]" />
          {label}
        </Button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-auto p-3">
        <div className="mb-3 flex flex-wrap gap-1.5">
          {DATE_PRESETS.map((p) => (
            <Button
              key={p.key}
              size="sm"
              variant={preset === p.key ? "default" : "outline"}
              data-testid={`date-preset-${p.key}`}
              onClick={() => {
                applyPreset(p.key);
                setOpen(false);
              }}
              className={`h-7 rounded-full px-3 text-xs ${
                preset === p.key ? "bg-[#18344A] text-white hover:bg-[#18344A]/90" : "border-[var(--pb-border)]"
              }`}
            >
              {p.label}
            </Button>
          ))}
        </div>
        <Calendar mode="range" selected={draft} onSelect={setDraft} numberOfMonths={1} />
        <div className="mt-2 flex justify-end">
          <Button
            size="sm"
            data-testid="date-range-filter-apply"
            onClick={applyCustom}
            className="h-8 rounded-full bg-[#18344A] px-4 text-xs text-white hover:bg-[#18344A]/90"
          >
            Apply custom range
          </Button>
        </div>
      </PopoverContent>
    </Popover>
  );
}
